import type { VideoaulaGateway } from '@/application/port/out/VideoaulaGateway';
import type { ListVideoaulasParams, UpsertVideoaulaCommand, Videoaula } from '@/domain/model/Videoaula';

export class ListVideoaulas {
  constructor(private readonly gateway: VideoaulaGateway) {}
  execute(params: ListVideoaulasParams = {}): Promise<Videoaula[]> { return this.gateway.list(params); }
}
export class CreateVideoaula {
  constructor(private readonly gateway: VideoaulaGateway) {}
  execute(cmd: UpsertVideoaulaCommand): Promise<Videoaula> { return this.gateway.create(cmd); }
}
export class UpdateVideoaula {
  constructor(private readonly gateway: VideoaulaGateway) {}
  execute(id: string, cmd: UpsertVideoaulaCommand): Promise<Videoaula> { return this.gateway.update(id, cmd); }
}
export class ArquivarVideoaula {
  constructor(private readonly gateway: VideoaulaGateway) {}
  execute(id: string): Promise<void> { return this.gateway.arquivar(id); }
}
